module.exports = {
      id: "quote-usage",
      viewBox: "0 0 32 33",
      url: __webpack_public_path__ + "img/icons.56e2db0a.svg#quote-usage",
      toString: function () {
        return this.url;
      }
    }